import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from 'model/response-model';
import { AuthState } from 'redux/authSlice';
import { DeleteProducts, ProductQuery, ProductUpdateCatModel, ProductUpdateDtoPaginationResult } from 'model/product-update-model';
import { baseQueryWithReauth } from './config/interceptor';

const basePath = 'product-update';

// Define a service using a base URL and expected endpoints
export const productUpdateApi = createApi({
  reducerPath: 'productUpdateApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['ProductUpdate'],
  endpoints: (builder) => ({
    getProductPackages: builder.query<ApiResponse<string[]>, void>({
      query: () => ({
        url: `${basePath}/packages`,
      }),
    }),
    addCategories: builder.mutation<ApiResponse<string>, string>({
      query: (categoryName) => ({
        url: `${basePath}/categories/${categoryName}`,
        method: 'POST'
      }),
    }),
    publishCommand: builder.mutation<ApiResponse<string>, [FormData, string]>({
      query: ([query, publishCommand]) => ({
        url: `${basePath}/${publishCommand}`,
        method: 'POST',
        body: query,
      }),
    }),
    getProductCategories: builder.query<ApiResponse<ProductUpdateCatModel[]>, void>({
      query: () => ({
        url: `${basePath}/categories`,
      }),
    }),
    getProduct: builder.query<ApiResponse<ProductUpdateDtoPaginationResult>, [ProductQuery, string]>({
      query: ([query, filterName]) => ({
        url: `${basePath}/${filterName}`,
        params: query
      }),
    }),
    getProductDraft: builder.query<ApiResponse<ProductUpdateDtoPaginationResult>, ProductQuery>({
      query: (query) => ({
        url: `${basePath}/draft`,
        params: query
      }),
    }),
    getProductDelete: builder.query<ApiResponse<ProductUpdateDtoPaginationResult>, ProductQuery>({
      query: (query) => ({
        url: `${basePath}/delete`,
        params: query
      }),
    }),
    deleteProduct: builder.mutation<ApiResponse<string>, DeleteProducts>({
      query: (productIds) => ({
        url: `${basePath}`,
        method: 'DELETE',
        body: productIds,
      }),
    }),   
  }),
});

// Export the auto-generated hooks
export const {
  useAddCategoriesMutation,
  usePublishCommandMutation,
  useGetProductCategoriesQuery,
  useGetProductDeleteQuery,
  useGetProductDraftQuery,
  useGetProductPackagesQuery,
  useGetProductQuery,
  useDeleteProductMutation
} = productUpdateApi;
